module.exports = "images/6ans.1b5cdede.png";